export interface Role {
	id: string,
	name: string,
}

export const DefaultRole: Role = {
	id: '',
	name: ''
}